import React from 'react'
import CaptureHawbDetails from './CaptureHawbDetails'

const CaptureHawb = ({ shipmentPrefix, masterDocumentNumber,hawbTrigger,setAlertMessage, setSuccess, alertMessage,success,  setIsLoading, isLoading,setIsHawbLocked, isHawbLocked }) => {
	return (
		<div className='form-row'>
			<div className='col-12'>
				<CaptureHawbDetails
					shipmentPrefix={shipmentPrefix}
					masterDocumentNumber={masterDocumentNumber}
					hawbTrigger={hawbTrigger}
					setAlertMessage={setAlertMessage} 
                    setSuccess={setSuccess}
					alertMessage={alertMessage}  
                    success={success}  
					setIsLoading={setIsLoading}
					isLoading={isLoading}
					setIsHawbLocked={setIsHawbLocked}
					isHawbLocked={isHawbLocked}
				/>
			</div>
		</div>
	)
}

export default CaptureHawb
